<template>
    <v-container class="h-100">
        <v-card  class="card-container">
            <v-card-title>
                <v-row>
                    <v-col cols="auto">
                        <v-btn-toggle
                                id="toggle-container"
                                v-model="activeTab"
                                dense
                                mandatory
                                style="border:1px solid grey"
                                tile
                                background-color="#FAFAFA"
                                color="#0156AD"
                                group
                                class="group-toggle"
                        >
                            <v-btn class="group-button" :value="0">
                                Новые
                            </v-btn>

                            <v-btn class="group-button" :value="1">
                                Активные
                            </v-btn>

                            <v-btn class="group-button" :value="2">
                                Архив
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <v-col>
                        <v-text-field
                                v-model="search"
                                prepend-inner-icon="mdi-magnify"
                                label="Поиск по заявкам"
                                hide-details
                                solo
                                dense
                        ></v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>

            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="p-0" style="height: calc(100% - 100px)">
                <newRequests v-if="activeTab==0" :search="search"/>
                <activeRequests v-if="activeTab==1" :search="search"/>
                <requestHistory v-if="activeTab==2" :search="search"></requestHistory>

            </v-card-text>
        </v-card>
    </v-container>



</template>

<script>
  import newRequests from '../components/Requests/RequestsNew'
  import requestHistory from '../components/Requests/RequestsHistory'
  import activeRequests from '../components/Requests/RequestActive'
    export default {
        name: "Requests",
      components:{newRequests, requestHistory, activeRequests},
      data(){
        return {
          activeTab:0,
            search:"",
        }
      },
      mounted(){
        //обнуляем количество уведомлений
        this.$store.dispatch("Notifications/removeNotification", 0)
      }
    }
</script>

<style scoped >
 #toggle-container.group-toggle{
    height: 40px;
     border-radius: 5px;
     border:2px solid #D3DAE1;
}
    #toggle-container.group-toggle>.group-button{
        opacity: 1;
        margin: 0;
        height: 39px;
        padding:  0 30px;
        text-transform: capitalize;
    }
 #toggle-container.group-toggle>.group-button.v-item--active{
     background-color: var(--color-blue) !important;
     border-radius: 4px;
     color:white;
 }

 #toggle-container.group-toggle>.group-button:not(.v-item--active){
     color:#6E7C8D;
 }
</style>
